import { createFileRoute } from '@tanstack/react-router'
import { OnboardingPage } from '#pages/client/OnboardingPage'

export const Route = createFileRoute('/_app/onboarding')({
  component: OnboardingPage,
})
